/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Button,
  Card,
  CardContent,
  InputAdornment,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useState } from "react";
import { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { deleteInvoicePdfFormatData, fetchInvoicePdfFormat } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import LoadingModal from "../../components/LoadingModel/loadingModal";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconMenu from "components/CustomMaterialMenu/Custom";
import SearchField from "components/SearchField/SearchField";

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "var(--surface-primary, #191b1f)",
    },
    context: {
      background: "var(--surface-primary, #191b1f)",
      text: "white",
    },
    divider: {
      default: "white",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
let searchParameter = "";

let routePath = "/InvoicePdfFormat";
const SCREEN_NAME = "Invoice Themes";
let SCREEN_RIGHT;

function InvoicePdfFormat() {
  let changePaginationText =
    document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName("span")[0].textContent =
      "Records Per Page";
  }
  const dispatch = useDispatch();
  const [disableColor, setDisableColor] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [title, setTitle] = useState("");
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [screenAccess, setScreenAccess] = useState(false);
  const [values, setValues] = useState({
    _id: [],
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: [
      "themeName",
      "fontStyle",
      "fontSize",
      "logoAlignment",
      "contactDetails",
      "showTaxNumber",
      "showColHead",
      "showItemCode",
      "showPriceQuantity",
      "showPaymentAdvice",
      "showTaxColumn",
      "showRegdAddress",
      "showLogo",
      "hideDiscount",
      "termsAndPaymentAdvice",
    ],
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      ?.businessUserID,
  });

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchedInvoicePdfFormat();
    })();
  }, [values.sortingType, perPage]);

  async function getRight() {
    let right = await getScreenRight(SCREEN_NAME);
    console.log("right", right);
    if (right === "Full Access") {
      setDisableColor(false);
      setScreenAccess(false);
    } else {
      setDisableColor(true);
      setScreenAccess(true);
    }
  }

  const handleCancel = (name) => (event) => {
    setSelectedRows([]);
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {
    values._id = _id;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteInvoicePdfFormat();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = (page) => {
    values.page = page;
    fetchedInvoicePdfFormat();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setToggleCleared(!toggleCleared);
    setSelectedRows([]);
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const deleteInvoicePdfFormat = async () => {
    await deleteInvoicePdfFormatData(
      values,
      (data) => {
        setValues({ ...values, _id: [] });
        fetchedInvoicePdfFormat();
        setToggleCleared(true);
        setTitle("");
        showResMsg(
          data.Result_Status ? genericMessage.deleted : data.Result_Message,
          1000,
          data.Result_Status
        );
      },
      dispatch
    );
  };

  const fetchedInvoicePdfFormat = async () => {
    await fetchInvoicePdfFormat(
      values,
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  let columns = [
    {
      name: <p style={{ fontSize: "12px" }}>Name</p>,
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.themeName}</span>
      ),
      sortable: true,
      sortField: "themeName",
      style: { paddingLeft: "10px" },
    },
    {
      name: <p style={{ paddingLeft: "30px", fontSize: "12px" }}>Font Style</p>,
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.fontStyle}</span>
      ),
      sortable: true,
      sortField: "fontStyle",
      center: true,
    },
    {
      name: <p style={{ paddingLeft: "30px", fontSize: "12px" }}>Font Size</p>,
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.fontSize}</span>
      ),
      sortable: true,
      sortField: "fontSize",
      center: true,
    },
    {
      name: (
        <p style={{ paddingLeft: "30px", fontSize: "12px" }}>Logo Alignment</p>
      ),
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.logoAlignment}</span>
      ),
      sortable: true,
      sortField: "logoAlignment",
      center: true,
    },
    {
      name: (
        <p
          style={{ paddingLeft: "0px", fontSize: "12px", textAlign: "center" }}
        >
          Business Details
        </p>
      ),
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.contactDetails}</span>
      ),
      sortable: true,
      sortField: "contactDetails",
      center: true,
      style: { paddingLeft: "10px", textAlign: "center" },
      minWidth: "200px",
    },
    {
      name: (
        <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Show Tax Number</p>
      ),
      selector: (row) =>
        `${row.showTaxNumber}` === "true" ? (
          <span style={{ color: "green", fontWeight: "800", fontSize: "12px" }}>
            &#10004;
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: "800", fontSize: "12px" }}>
            &#10006;
          </span>
        ),
      sortable: true,
      sortField: "showTaxNumber",
      center: true,
    },
    {
      name: (
        <p style={{ paddingLeft: "20px", fontSize: "12px" }}>
          Show Column Heading
        </p>
      ),
      selector: (row) =>
        `${row.showColHead}` === "true" ? (
          <span style={{ color: "green", fontWeight: "800", fontSize: "12px" }}>
            &#10004;
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: "800", fontSize: "12px" }}>
            &#10006;
          </span>
        ),
      sortable: true,
      sortField: "showColHead",
      center: true,
    },
    {
      name: (
        <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Show Item Code</p>
      ),
      selector: (row) =>
        `${row.showItemCode}` === "true" ? (
          <span style={{ color: "green", fontWeight: "800", fontSize: "12px" }}>
            &#10004;
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: "800", fontSize: "12px" }}>
            &#10006;
          </span>
        ),
      sortable: true,
      sortField: "showItemCode",
      center: true,
    },
    {
      name: (
        <p style={{ paddingLeft: "20px", fontSize: "12px" }}>
          Show Price Quantity
        </p>
      ),
      selector: (row) =>
        `${row.showPriceQuantity}` === "true" ? (
          <span style={{ color: "green", fontWeight: "800", fontSize: "12px" }}>
            &#10004;
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: "800", fontSize: "12px" }}>
            &#10006;
          </span>
        ),
      sortable: true,
      sortField: "showPriceQuantity",
      center: true,
    },
    // {
    //     name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Show Payment Advice</p>,
    //     selector: row => `${row.showPaymentAdvice}` === 'true' ? <span style={{ color: 'green', fontWeight: '800', fontSize: '12px' }}>&#10004;</span> : <span style={{ color: 'red', fontWeight: '800', fontSize: '12px' }}>&#10006;</span>,
    //     sortable: true,
    //     sortField: 'showPaymentAdvice',
    //     center: true,
    // },
    {
      name: (
        <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Show Tax Column</p>
      ),
      selector: (row) =>
        `${row.showTaxColumn}` === "true" ? (
          <span style={{ color: "green", fontWeight: "800", fontSize: "12px" }}>
            &#10004;
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: "800", fontSize: "12px" }}>
            &#10006;
          </span>
        ),
      sortable: true,
      sortField: "showTaxColumn",
      center: true,
    },
    {
      name: (
        <p style={{ paddingLeft: "22px", fontSize: "12px" }}>
          Show Registered Address
        </p>
      ),
      selector: (row) =>
        `${row.showRegdAddress}` === "true" ? (
          <span style={{ color: "green", fontWeight: "800", fontSize: "12px" }}>
            &#10004;
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: "800", fontSize: "12px" }}>
            &#10006;
          </span>
        ),
      sortable: true,
      sortField: "showRegdAddress",
      center: true,
    },
    {
      name: <p style={{ paddingLeft: "22px", fontSize: "12px" }}>Show Logo</p>,
      selector: (row) =>
        `${row.showLogo}` === "true" ? (
          <span style={{ color: "green", fontWeight: "800", fontSize: "12px" }}>
            &#10004;
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: "800", fontSize: "12px" }}>
            &#10006;
          </span>
        ),
      sortable: true,
      sortField: "showLogo",
      center: true,
    },
    {
      name: (
        <p style={{ paddingLeft: "22px", fontSize: "12px" }}>Hide Discount</p>
      ),
      selector: (row) =>
        `${row.hideDiscount}` === "true" ? (
          <span style={{ color: "green", fontWeight: "800", fontSize: "12px" }}>
            &#10004;
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: "800", fontSize: "12px" }}>
            &#10006;
          </span>
        ),
      sortable: true,
      sortField: "hideDiscount",
      center: true,
    },
    {
      name: (
        <p style={{ paddingLeft: "16px", fontSize: "12px" }}>
          Terms & Conditions
        </p>
      ),
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.termsAndPaymentAdvice}</span>
      ),
      sortable: true,
      sortField: "termsAndPaymentAdvice",
      center: true,
    },
    {
      name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
      selector: (row) => <span style={{ fontSize: "12px" }}>{row._id}</span>,

      center: true,
      cell: (row) => (
        <IconMenu
          size="small"
          row={
            <>
              <Grid item>
                <Link
                  to={`/invoicePdfFormat/editInvoicePdfFormat/${row._id}`}
                  disabled={!screenAccess}
                >
                  <p style={darkMode ? { color: "white" } : { color: "black" }}>
                    <TimelineItem
                      color="success"
                      icon={<EditIcon className="actionicon" />}
                      title="Edit"
                    />{" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit
                  </p>
                </Link>
              </Grid>
              <Grid item>
                <p
                  style={darkMode ? { color: "white" } : { color: "black" }}
                  data-clickable="true"
                  onClick={() => handleDeleteDialogeClick(row._id)}
                  disabled={!screenAccess}
                >
                  <TimelineItem
                    color="error"
                    icon={<DeleteIcon className="actionicon" />}
                    onClick={() => handleDeleteDialogeClick(row._id)}
                    title="Delete"
                  />{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete
                </p>
              </Grid>
              {/* </Grid> */}
            </>
          }
        />
      ),
    },
  ];
  const handleSearchInputValue = useCallback((searchInput) => {
    setValues((prevValues) => ({ ...prevValues, filterValues: searchInput }));
  }, []);

  const getSearchResult = useCallback(() => {
    fetchedInvoicePdfFormat();
  }, [values.filterValues]);
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName="Invoice Themes" />
          <Grid container display={"flex"} justifyContent="end" mt={2} gap={2}>
            <Grid lg={2.5} xs={6}>
              <SearchField
                tableBorder={tableBorder}
                searchValue={values.filterValues}
                setSearchValue={handleSearchInputValue}
                getSearchResult={getSearchResult}
              />
              {/* <TextField
                                type="text"
                                variant="outlined"
                                fullWidth
                                className="searchButton"
                                placeholder="Search..."
                                label="Search Filter"
                                value={values.filterValues}
                                onChange={handleSearchFilter}
                                onKeyUp={(e) => {
                                    if (e.key === "Enter") fetchedInvoicePdfFormat();
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment  >
                                            <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchedInvoicePdfFormat}>
                                                <GridSearchIcon color="white" />
                                            </Button>
                                        </InputAdornment>
                                    ),
                                }}
                            /> */}
            </Grid>
            <div style={{ marginRight: "16px" }}>
              {/* <Link to={"/invoicePdfFormat/addInvoicePdfFormat"}>
                                <MDButton
                                    variant="contained"
                                    color="success"
                                    style={{ height: "38.11px" }}
                                >
                                    Add New
                                </MDButton>
                            </Link> */}
              {screenAccess ? (
                <Link to={"/invoicePdfFormat/addInvoicePdfFormat"}>
                  <MDButton
                    variant="contained"
                    color="success"
                    style={{ height: "38.11px" }}
                  >
                    Add New
                  </MDButton>
                </Link>
              ) : (
                <MDButton
                  variant="contained"
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color="secondary"
                  style={{ height: "38.11px" }}
                >
                  Add New
                </MDButton>
              )}
            </div>
          </Grid>
          {/* <CardContent> */}
          <BTable
            columns={columns}
            data={rows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>
      </div>
      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
        message={deleteHeading}
      />
    </DashboardLayout>
  );
}

export default InvoicePdfFormat;
